import { ConstraintUIValues } from "./ConstraintUIValues";
import { FlagColorList } from "./FlagColorList";

export class ConstarintUIModels {
  id: string;
  displayName: string;
  name: string;
  type: string;
  label: string;
  values: ConstraintUIValues[] = [];
  flagColorUI: FlagColorList[];
  calendarObj: CalendarView[] = [];
  isDisabled?: boolean; //To disable the div for vation filters if vacation disabled
  isHidden?: boolean; //To hide the filter div for vation filters if Swaptimizer/Normal Vaction not contain such filter from preset
  multiOrder?: number; //For filter with multiple time
  isSortScratchpad: boolean;
}

export class CalendarView {
  id: number;
  day: string;
  isEnabled: boolean;
  isSelected: boolean;
  isPrevMonth?: boolean;
  dateString: string;
  dateIndex: number;
}
